export class ExportOrderKey {
  constructor(private value: string) {}

  getValue(): string {
    return this.value;
  }
}
